import { ReactElement } from 'react';

import { ChatContainer } from '../layout/chatContainer';
import { LoadingAnimation } from './animation';

export const LoadingView = (): ReactElement => (
	<ChatContainer>
		<LoadingAnimation />
	</ChatContainer>
);
